import React, { CSSProperties, useEffect, useState } from 'react';
import { getSVGHeight } from '../svg-provider';
import { IIconProps } from '../interfaces';

const ArrowIcon = (props: IIconProps) => {

    const [ height, setHeight ] = useState(props.height);
    const [ style, setStyle ] = useState<CSSProperties|undefined>();

    const { width, rotationAngle } = props;

    useEffect(() => {

        // if height property is not defined, and width & height should be defined in px ->
        // calculate the height dynamically, keeping the aspect ratio using the viewport
        if(height === undefined && width.endsWith('px')){
            setHeight(getSVGHeight(width, 11, 7));
        }

        if(!isNaN(Number(rotationAngle))){
            const angle = `rotate(${ rotationAngle }deg)`;

            const style = props.style ? { ...props.style } : {};
            style.WebkitTransform = angle;
            style.msTransform = angle;
            style.transform = angle;

            setStyle(style)
        }
    }, [height, width, rotationAngle, props.style]);

    return (
        <svg
            width={ props.width }
            height={ height }
            className={ props.classes }
            style={ style }
            viewBox="0 0 11 7"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink">
            { props.title && <title>{ props.title }</title> }
            <defs><path d="M45.646 5.143a.915.915 0 0 0 0 1.293l3.552 3.56-3.552 3.56a.915.915 0 0 0 1.293 1.294l4.853-4.854-4.853-4.854a.914.914 0 0 0-1.293 0z" id="a"/></defs><use fill={ props.color } transform="matrix(0 1 1 0 -4.6 -45.4)" xlinkHref="#a" fillRule="evenodd"/></svg>
    )
};

export default ArrowIcon;
